module.exports = __webpack_public_path__ + "assets/img/block-1f42accd.png";